import { useState, useMemo } from 'react'
import { useTenantContext } from '@/context/TenantContext'
import { forcyteService } from '@/services'
import { setTenantTimezone, clearTenantTimezone } from '@/utils'
import portalDefaults from '@/assets/portal-constants/defaults.json'

const BASE_URL = '/admin'

export const useTenant = () => {
  const [tenant, setTenant] = useState(null)
  const [loadingTenant, setLoadingTenant] = useState(true)

  const getTenant = async () => {
    try {
      setLoadingTenant(true)
      const response = await forcyteService.get(`${BASE_URL}/portal-config`)
      setTenant(response?.data)
      const timezoneCode = response?.data?.timezone_code
      const hasTimezone = setTenantTimezone({
        code: timezoneCode,
        name: response?.data?.timezone_name,
      })
      if (!hasTimezone) {
        console.error('Tenant timezone missing or unrecognized:', timezoneCode)
      }
    } catch (error) {
      console.error('Failed to load tenant config:', error)
      setTenant(null)
      clearTenantTimezone()
    } finally {
      setLoadingTenant(false)
    }
  }

  return { tenant, loadingTenant, getTenant }
}

export const usePortalConstantValue = () => {
  const { tenant } = useTenantContext()

  const portalConstants = useMemo(() => {
    return tenant?.portal_constants || {}
  }, [tenant])

  return useMemo(() => {
    return key => {
      return portalConstants[key] || portalDefaults[key]
    }
  }, [portalConstants])
}
